// test1886
(1886 && 0);
